import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useFormContext } from 'react-hook-form';
import { mapContractType } from 'tdc-web-backend/enums/enums';
import { useParams } from 'react-router-dom';
import CustomInputSelect from '../../../../components/custom-input/inputs/CustomInputSelect';
import CustomInput from '../../../../components/custom-input/CustomInput';
import CustomInputCheckbox from '../../../../components/custom-input/inputs/CustomInputCheckbok';

const Header = ({ text }: { text: string }) => (
  <Typography variant="h4" fontSize="1.5rem">
    {text}
  </Typography>
);
const Subheader = ({ text }: { text: string }) => (
  <Typography variant="h5" fontSize="1rem">
    {text}
  </Typography>
);

const SettingsForm = () => (
  <Accordion
    sx={{
      py: 1,
      boxShadow: 'none',
    }}
    defaultExpanded
  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon justity-content="flex-end" fontSize="large" />}
      aria-controls="panel1a-content"
      id="panel1a-header"
      sx={{ px: 4 }}
    >
      <Stack direction="column" spacing={1}>
        <Stack direction="row" spacing={1}>
          <Header text="Settings" />
        </Stack>
        <Subheader text="Company settings" />
      </Stack>
    </AccordionSummary>

    <AccordionDetails
      sx={{
        p: 4,
        borderTop: '1px solid',
        borderTopColor: 'grey.500',
      }}
    >
      <Stack direction="column" spacing={5}>
        <CustomInput
          input={<CustomInputSelect />}
          name="defaultContractType"
          choices={mapContractType}
          label="Contract type"
          placeholder="Select default contract type"
          rules={{ required: 'Contract type is required' }}
          sx={{ minHeight: 'none', maxWidth: '600px' }}
        />
        <CustomInput
          input={<CustomInputCheckbox />}
          name="subscriptionExempt"
          label="Exempt from subscription"
          sx={{ minHeight: 'none' }}
        />
      </Stack>
    </AccordionDetails>
  </Accordion>
);

export default SettingsForm;
